export enum BusinessUnits {
  Farly = "farly",
  Widely = "widely",
  Mobsuccess = "mobsuccess",
  Storysuccess = "storysuccess",
  Leboncoin = "leboncoin",
}
